import { qsa } from '@fluorescent/dom';
import { section } from '@/glow';
import { emit } from '@/glow/events';

import { backgroundVideoHandler } from '@/lib/a11y';

const selectors = {
  video: '.video-hero__video',
};

section('video-hero', {
  onLoad() {
    const videos = qsa(selectors.video, this.container);
    this.videoHandlers = [];

    if (videos.length) {
      videos.forEach(video => {
        this.videoHandlers.push(backgroundVideoHandler(video.parentNode));
      });
    }
  },

  onSelect() {
    emit('transparentSectionUpdate');
  },

  onUnload() {
    this.videoHandlers.forEach(handler => handler());
  },
});
